import React from 'react'
import { VuiButton } from '@topkamera/viso-ui'

export const mapChartDataToPreviewProps = ({ chart, dashboardDetails, color, devicesData, previewDevices }) => {
  if (!chart) return {}

  const randomNumber = Math.floor(Math.random() * 100000)
  const configuration = chart.configuration || {}
  const chartType = configuration.chartType || chart.type
  const tableName = chart.tableName || configuration.tableName || ''
  const streamsConfig = configuration.dataStreams || {}
  const streams = streamsConfig.streams || []
  const metricColumns = streams
    .map((stream) => {
      if (stream?.metric?.metrics) return stream.metric.metrics
      if (Array.isArray(stream?.metrics)) return stream.metrics
      if (stream?.metric) return [stream.metric]
      return []
    })
    .flat()
  const groupByColumns = configuration.groupBy?.metrics || []
  const intervalOption = configuration.analysisInterval?.value || ''
  const intervalQuantity =
    configuration.analysisInterval?.quantity != null
      ? String(configuration.analysisInterval.quantity)
      : ''
  const timeRange = configuration.timeRange || {}
  const chartValues = {
    ...configuration,
    chartType,
    chartTitle: configuration.chartTitle || chart.title || '',
    timeRange,
    dataStreams: streamsConfig,
    devices: previewDevices?.length > 0 ? previewDevices : devicesData.map(device => device.label)
  }
  const mapDevicesData = devicesData.filter(device => previewDevices?.includes(device.label)).map(device => ({ ...device, name: device.label }))

  return {
    chartType,
    height: 380,
    sqlError: null,
    chartConfig: {},
    dashboardDate: undefined,
    selectedDate: undefined,
    tableName,
    metricColumns,
    dataPoint: configuration.dataPoint || '',
    metricAggregations: configuration.metricAggregations || [],
    intervalOption,
    intervalQuantity,
    groupByColumns,
    visoDevices: previewDevices,
    timeRange,
    isLoading: false,
    devicesData: mapDevicesData,
    color,
    refreshPreview: false,
    isNewVersion: true,
    chartValues,
    dashboardId: chart.dashboardId || dashboardDetails?._id,
    dataStreams: chart.dataStreams || [],
    previewId: randomNumber,
    changeChartValue: () => { }
  }
}

export const renderOptionChips = (options = []) => {
  const mapOptions = options.map((option, index) => {
    const mapContent = () => Object.entries(option || {}).map(([key, value]) => (
      <div key={key}>{key.charAt(0).toUpperCase() + key.slice(1)}: {value}</div>
    ))
    return {
      title: `Option ${String.fromCharCode(65 + index)}`,
      value: index,
      text: <>{mapContent()}</>
    }
  })
  return mapOptions
}

export const RenderDemoApp = ({
  data = {}, color, onViewDemo = () => { }
}) => {
  const { name, demoPitch, id } = data || {}
  
  const downloadScript = () => {
    const blob = new Blob([demoPitch], { type: 'text/markdown' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `${name || 'script'}.md`
    a.click()
    URL.revokeObjectURL(url)
  }

  return (
    <div className='vui-flex vui-flex-column vui-gap-8'>
      {name && <div className='vui-bold'>{name}</div>}
      <div>Your demo app and script are ready.</div>
      {demoPitch && (
        <div className='vui-flex vui-gap-12 vui-pt-4'>
          {id &&
            <VuiButton
              label='View Demo App'
              size='sm'
              color={color}
              onClick={() => onViewDemo(id)}
              style='light'
              radius='rounded'
              iconLeft='barsVertical'
              iconSize='xs'
            />
          }
          <VuiButton
            label='Download Script'
            size='sm'
            color={color}
            onClick={downloadScript}
            iconLeft='download'
            iconSize='xs'
          />
        </div>
      )}
    </div>
  )
}

export const selectOptionChip = ({ option, onAskAgent, chatId }) => {
  const mapContent = Object.entries(option || {}).map(([key, value]) => `${key}: ${value}`)
  onAskAgent(`I would like the option with ${mapContent?.[0] || ''}`, chatId)
}